import { querySelectorAllDeep } from 'query-selector-shadow-dom';
import { DebugService } from './debug.service.js';

class _FormValidationService {
  constructor() {
    this.debug = new DebugService('FormValidationService');
  }

  async validateAllFields(form) {
    this.debug.log('validateAllFields called with', form);
    const inputs = querySelectorAllDeep(
      'fs-ssn-field, fs-currency-field, input, select, textarea',
      form
    );
    let firstInvalid = null;
    let focused = false;
    await inputs.forEach(async (input) => {
      this.debug.log(
        `To validate - input.id: ${input.id}, input.name: ${input.name}`
      );
      if (
        input.name !== 'ownerStatus' &&
        input.name !== 'co-ownerStatus' &&
        (input.id !== 'input' ||
          (input.name !== 'incomeAmount' &&
            input.name !== 'otherIncome' &&
            input.name !== 'monthlyPayment' &&
            input.name !== 'co-monthlyPayment' &&
            input.name !== 'housing-monthly-payment'))
      ) {
        const valid = await input.validity.valid;
        this.debug.log(
          `Validated - input.id: ${input.id}, input.name: ${input.name}, valid: ${valid} - `
        );
        if (!valid) {
          if (firstInvalid === null) {
            firstInvalid = input;
          }
          input.focus();
          input.blur();
          focused = true;
        }
      }
    });
    return !focused;
  }
}

export const FormValidationService = new _FormValidationService();
